import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { SELECT_PLANT_URL } from '../../../constants/navigation.constants'
import { useCustomTranslation } from '../../../infrastructure/translation/useCustomTranslation'
import { IconWrapper, SearchRedirect } from './plantSearch.styles'

const PlantSearchRedirect = (): React.ReactElement => {
  const { t } = useCustomTranslation('common')
  return (
    <SearchRedirect to={SELECT_PLANT_URL}>
      <IconWrapper>
        <FontAwesomeIcon icon="search" />
      </IconWrapper>
      <div>{`${t('search_plant')}...`}</div>
    </SearchRedirect>
  )
}

export default PlantSearchRedirect
